module.exports = __webpack_public_path__ + "guahao/img/logo.1a7189a0.png";